import { Thread, ThreadMessage, ThreadParticipant } from '../types/thread';

type ThreadRole = 'CLIENT' | 'CREATOR';

/**
 * Convert a TIM conversation to our Thread type
 */
export function timConversationToThread(
  conv: any,
  currentUserId: string,
  currentUserRole: ThreadRole = 'CLIENT'
): Thread {
  const isC2C = conv.type === 'C2C';
  const partnerId = isC2C ? conv.conversationID.replace('C2C', '') : conv.groupProfile?.groupID || '';
  const partnerProfile = conv.userProfile || {};
  const partnerRole: ThreadRole = currentUserRole === 'CREATOR' ? 'CLIENT' : 'CREATOR';

  const participants: ThreadParticipant[] = [
    {
      userId: currentUserId,
      nickname: 'Me',
      role: currentUserRole,
      lastReadAt: Date.now(),
    },
    {
      userId: partnerId,
      nickname: partnerProfile.nick || partnerId,
      avatar: partnerProfile.avatar || '',
      role: partnerRole,
      lastReadAt: Date.now(),
    },
  ];

  return {
    id: conv.conversationID,
    participants,
    lastMessage: conv.lastMessage ? {
      id: conv.lastMessage.ID || '',
      threadId: conv.conversationID,
      senderId: conv.lastMessage.from || '',
      type: conv.lastMessage.type === 'TIMTextElem' ? 'TEXT' : 'SYSTEM',
      content: conv.lastMessage.messageForShow || '',
      createdAt: (conv.lastMessage.time || 0) * 1000,
      isRead: true,
    } : undefined,
    category: 'GENERAL',
    unreadCount: conv.unreadCount || 0,
    updatedAt: (conv.lastMessage?.time || 0) * 1000,
  };
}

/**
 * Convert a TIM message to our ThreadMessage type
 */
export function timMessageToThreadMessage(msg: any): ThreadMessage {
  const isCustom = msg.type === 'TIMCustomElem';
  let type: ThreadMessage['type'] = 'TEXT';
  let content = '';
  let payload: any;

  if (isCustom && msg.payload?.data) {
    try {
      const data = JSON.parse(msg.payload.data);
      if (data.type === 'PROPOSAL') {
        type = 'PROPOSAL';
        payload = data.payload;
        content = data.content || '我提交了一份合作方案，请查收。';
      } else if (data.type === 'INVITATION') {
        type = 'INVITATION';
        payload = data.payload;
        content = data.content || '发起合作邀请';
      } else if (data.type === 'TRIAL_REQUEST') {
        type = 'TRIAL_REQUEST';
        payload = data.payload;
        // Attempt to restore persistent local status for mock environments
        if (typeof window !== 'undefined' && payload) {
            const savedStatusByMessageId = msg.ID
              ? localStorage.getItem(`trial_status_${msg.ID}`)
              : null;
            const savedStatusByTrialId = payload.trialId
              ? localStorage.getItem(`trial_status_by_trial_${payload.trialId}`)
              : null;
            const restoredStatus = savedStatusByMessageId || savedStatusByTrialId;
            if (restoredStatus) {
                payload.status = restoredStatus;
            }
        }
        content = data.content || '发起试稿请求';
      } else if (data.type === 'SYSTEM') {
        type = 'SYSTEM';
        content = data.content || msg.payload.description || '[系统消息]';
        payload = data.payload;
      } else {
        content = data.content || msg.payload.description || '[自定义消息]';
      }
    } catch {
      content = msg.payload.description || '[自定义消息]';
    }
  } else {
    content = msg.payload?.text || msg.messageForShow || '';
  }

  return {
    id: msg.ID || '',
    threadId: msg.conversationID || '',
    senderId: msg.from || '',
    type,
    content,
    createdAt: (msg.time || 0) * 1000,
    isRead: msg.isRead ?? true,
    ...(payload && { payload }),
  };
}
